import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
  } from "@progress/kendo-react-grid";
  import { Icon } from "@iconify/react";


const UpcomingJoinee = (props: any) => {

    const contractDurationCell = (duration: GridCellProps) => {
    
        return (
          <td>
            {duration && duration.dataItem.contractStartDate ? new Date(parseInt(duration.dataItem.contractStartDate)).toDateString().slice(3) + ' - ' : 'Not mentioned'} {(duration && duration.dataItem.contractEndDate && duration.dataItem.contractStartDate) ? duration.dataItem.contractEndDate && new Date(parseInt(duration.dataItem.contractEndDate)).toDateString().slice(3): duration.dataItem.contractEndDate ? 'In progress' : ''}
         </td>
       )
     }
      

    return (
        <div>
          <Grid
              data={props.data}           
          >
              <GridNoRecords>
                <div className="noData">
                  <Icon icon="mdi:smiley-neutral-outline" />
                  No data to display
                </div>
            </GridNoRecords>
              <Column field="fullName" title="Full Name" />
              <Column field="jobRole" title="Role" />
              <Column field="contractDuration" title="Contract Duration" cell={contractDurationCell} />
  
          </Grid>  
      </div>
    )
}

export default UpcomingJoinee